import { Navigate, Outlet, type RouteObject } from 'react-router-dom';
import SignInRequired from '../components/SignInRequired';
import { accountRoutes } from './account';
import { collectionsRoutes } from './collections';
import { conversationsRoutes } from './conversations';
import { homeRoutes } from './home';
import { invitationsRoutes } from './invitations';
import { listingsRoutes } from './listings';
import { isOpenToSignedOut } from './signedOut';

const areaRoutes = [
  ...homeRoutes,
  ...collectionsRoutes,
  ...listingsRoutes,
  ...invitationsRoutes,
  ...conversationsRoutes,
  ...accountRoutes,
];

/**
 * Every area's routes. Only those marked `OPEN_TO_SIGNED_OUT` show to someone
 * signed out; the rest send them to sign-in and back, including the reload
 * that follows a 401 (`onSessionEnded`). Anything unknown goes home.
 */
export const appRoutes: RouteObject[] = [
  ...areaRoutes.filter(isOpenToSignedOut),
  {
    element: (
      <SignInRequired>
        <Outlet />
      </SignInRequired>
    ),
    children: [
      ...areaRoutes.filter((route) => !isOpenToSignedOut(route)),
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
];
